<template>
	<component
		v-bind:is="blank ? 'layout-blank' : 'layout-splash'"
		title="Register"
	>
		<div class="flex flex-wrap h-full">
			<form class="w-full md:w-2/3 flex flex-col">
				<div class="flex-grow p-6">
					<span v-if="locale == 'de'">
						<h1 class="text-4xl mb-2 text-gray-900 font-bold">
							Jetzt bei cropspot registrieren
						</h1>
						<p class="text-2xl text-gray-700">Kostenlos und unverbindlich!</p>
					</span>
					<span v-else>
						<h1 class="text-4xl mb-2 text-gray-900 font-bold">
							Register now at cropspot
						</h1>
						<p class="text-2xl text-gray-700">Free and without obligations!</p>
					</span>

					<div class="mt-6 grid grid-cols-6 gap-y-4 gap-x-6">
						<ui-select-group
							class="col-span-2"
							v-model="form.salutation"
							type="select"
							field="salutation"
							label="Salutation"
							:options="$cropOptions.salutationOptions"
							:form="form"
							:required="true"
							:placeholder="false"
						></ui-select-group>

						<ui-input-group
							class="col-span-4"
							v-model="form.title"
							field="name"
							label="title.title"
							:form="form"
							:required="false"
						></ui-input-group>

						<ui-input-group
							class="col-span-6"
							v-model="form.first_name"
							field="first_name"
							label="First Name"
							:form="form"
							:required="true"
						></ui-input-group>

						<ui-input-group
							class="col-span-6"
							v-model="form.last_name"
							field="last_name"
							label="Last Name"
							:form="form"
							:required="true"
						></ui-input-group>

						<ui-input-group
							class="col-span-6 md:col-span-4"
							v-model="form.email"
							field="email"
							label="E-mail"
							type="email"
							:form="form"
							:required="true"
						></ui-input-group>

						<ui-input-group
							class="col-span-6 md:col-span-2"
							v-model="form.tel_mobile"
							field="tel_mobile"
							label="Telephone (Mobile)"
							type="text"
							autocomplete="tel"
							:form="form"
							:required="true"
						></ui-input-group>

						<ui-input-group
							class="col-span-3"
							v-model="form.password"
							autocomplete="new-password"
							field="password"
							label="Password"
							type="password"
							:form="form"
							:required="true"
						></ui-input-group>

						<ui-input-group
							class="col-span-3"
							v-model="form.password_confirmation"
							autocomplete="new-password"
							field="password_confirmation"
							label="Password confirmation"
							type="password"
							:form="form"
							:required="true"
						></ui-input-group>

						<div class="col-span-6 text-gray-500 -mt-2">
							{{ __("The password should have at least 8 characters") }}
						</div>

						<ui-check-group
							class="col-span-6 flex mt-2"
							v-model="form.consent.general_terms"
							field="consent.general_terms"
							:form="form"
							:required="true"
						>
							<span v-if="locale == 'de'" class="block">
								Ich stimme den
								<a
									href="https://www.cropspot.com/agb.pdf"
									target="_blank"
									class="underline"
									>Allgemeinen Geschäftsbedingungen (AGB)</a
								>
								zu
							</span>
							<span v-else>
								I agree to the
								<a
									href="https://www.cropspot.com/agb.pdf"
									target="_blank"
									class="underline"
									>General Terms and Conditions</a
								>
							</span>
						</ui-check-group>

						<ui-check-group
							class="col-span-6 flex mt-2"
							v-model="form.consent.privacy"
							field="consent.privacy"
							:form="form"
							:required="true"
						>
							<span v-if="locale == 'de'">
								Ich stimme der
								<a
									href="https://www.cropspot.com/datenschutz.pdf"
									target="_blank"
									class="underline"
									>Datenschutzerklärung</a
								>
								zu
							</span>
							<span v-else>
								I agree to the
								<a
									href="https://www.cropspot.com/datenschutz.pdf"
									target="_blank"
									class="underline"
									>Data Protection Policy</a
								>
							</span>
						</ui-check-group>
					</div>
				</div>

				<div
					class="flex justify-end pt-4 pb-6 px-6 bg-gray-50 sm:rounded-b-xl justify-between"
				>
					<ui-icon class="w-12" name="ssl-logo" stroke-width="2" />
					<ui-button
						v-on:click="submit()"
						type="primary"
						label="Sign up now!"
					/>
				</div>
			</form>

			<content-register-step1-side />
		</div>
	</component>
</template>

<script>
export default {
	props: {
		blank: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: this.$inertia.form({
				company_name: "",
				name: "",
				first_name: "",
				last_name: "",
				salutation: "",
				title: "",
				tel_mobile: "",
				email: "",
				consent: {
					general_terms: false,
					privacy: false,
				},
				password: "",
				password_confirmation: "",
			}),
		};
	},
	methods: {
		submit() {
			let form = this.form;
			let that = this;
			this.form.post(this.$route("register"), {
				onError() {
					console.log("ERROR", form.errors);
				},
				onSuccess() {
					console.log("ANALYTICS_EMIT_NEW_REGISTRATION");
					that.$bus.$emit("analytics:new-registration");
				},
			});
		},
	},
};
</script>

<style scoped>
label {
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
}
</style>
